import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/HomePage.vue';
import CooperateMode from '../views/travelCard/CooperateMode.vue';
import FeedbackForm from '../views/travelCard/FeedbackForm.vue';
import IncomeDetails from '../views/travelCard/IncomeDetails.vue';
import IntroductionPage from '../views/travelCard/IntroductionPage.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/Article/:id',
      name: 'article',
      component: () => import('../views/TheArticle.vue')
    },
    {
      path: '/introduce/:img',
      name: 'introduce',
      component: IntroductionPage
    },
    {
      path: '/cooperate/:img',
      name: 'cooperate',
      component: CooperateMode
    },
    {
      path: '/income/:img',
      name: 'income',
      component: IncomeDetails
    },
    {
      path: '/feedback/:img',
      name: 'feedback',
      component: FeedbackForm
    }
  ]
});